export const selectListBlur = questionId => ({
  type: 'SELECT_LIST_BLUR',
  questionId,
});

export const selectListChange = (value, checked, questionId) => ({
  type: 'CONTROL_CHANGE',
  checked,
  questionId,
  value,
});

export const matrixControlChange = (value, checked, rowIndex, questionId) => ({
  type: 'MATRIX_BUTTON_CHANGE',
  checked,
  questionId,
  rowIndex,
  value,
});

export const matrixDropdownChange = (value, rowIndex, questionId) => ({
  type: 'MATRIX_SELECT_CHANGE',
  questionId,
  rowIndex,
  value,
});

export const matrixSliderChange = (value, rowIndex, questionId) => ({
  type: 'MATRIX_SELECT_CHANGE',
  questionId,
  rowIndex,
  value,
});

export const selectListDropdownChange = (value, questionId) => ({
  type: 'CONTROL_CHANGE',
  questionId,
  value,
});

export const matrixBlur = (rowIndex, questionId) => ({
  type: 'MATRIX_BLUR',
  questionId,
  rowIndex,
});
